import { render, staticRenderFns } from "./WidgetReviewsGalleryPc.vue?vue&type=template&id=d006fef2"
import script from "./WidgetReviewsGalleryPc.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsGalleryPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports